// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2vUcE","log":"ModalInventoryLogs_log__1teDh","date":"ModalInventoryLogs_date__1KW8X","userName":"ModalInventoryLogs_userName__1kaKz"};